export const Ludhiana = [
    {
        id: 1,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407703/WhatsApp_Image_2025-02-01_at_11.56.58_AM_mxmznu.jpg",
        alt: "Ludhiana Event 1",
    },
    {
        id: 2,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407702/WhatsApp_Image_2025-02-01_at_11.56.57_AM_hejzty.jpg",
        alt: "Ludhiana Event 2",
    },
    {
        id: 3,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407700/WhatsApp_Image_2025-02-01_at_11.56.57_AM_1_cqlpit.jpg",
        alt: "Ludhiana Event 3",
    },
    {
        id: 4,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407699/WhatsApp_Image_2025-02-01_at_11.56.55_AM_zgconv.jpg",
        alt: "Ludhiana Event 4",
    },
    {
        id: 5,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407700/WhatsApp_Image_2025-02-01_at_11.56.56_AM_ihipvs.jpg",
        alt: "Ludhiana Event 5",
    },
    {
        id: 6,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407641/WhatsApp_Image_2025-02-01_at_11.56.54_AM_pqdamq.jpg",
        alt: "Ludhiana Event 6",
    },
    {
        id: 7,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407640/WhatsApp_Image_2025-02-01_at_11.56.53_AM_bv5lmk.jpg",
        alt: "Ludhiana Event 7",
    },
    {
        id: 8,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407639/WhatsApp_Image_2025-02-01_at_11.56.51_AM_vwxtoz.jpg",
        alt: "Ludhiana Event 8",
    },
    {
        id: 9,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407637/WhatsApp_Image_2025-02-01_at_11.56.48_AM_bafwbw.jpg",
        alt: "Ludhiana Event 9",
    },
    {
        id: 10,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407635/WhatsApp_Image_2025-02-01_at_11.56.46_AM_ejwtwt.jpg",
        alt: "Ludhiana Event 10",
    },
    {
        id: 11,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407635/WhatsApp_Image_2025-02-01_at_11.56.45_AM_kkqb54.jpg",
        alt: "Ludhiana Event 11",
    },
    {
        id: 12,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407634/WhatsApp_Image_2025-02-01_at_11.56.44_AM_mthhdf.jpg",
        alt: "Ludhiana Event 12",
    },
    {
        id: 13,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407633/WhatsApp_Image_2025-02-01_at_11.56.43_AM_xeh3sy.jpg",
        alt: "Ludhiana Event 13",
    },
    {
        id: 14,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407633/WhatsApp_Image_2025-02-01_at_11.56.42_AM_x6ygbh.jpg",   
        alt: "Ludhiana Event 14",
    },
    {
        id: 15,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407632/WhatsApp_Image_2025-02-01_at_11.56.41_AM_rn1sfj.jpg",
        alt: "Ludhiana Event 15",
    },
    {
        id: 16,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407631/WhatsApp_Image_2025-02-01_at_11.56.40_AM_vstahe.jpg",
        alt: "Ludhiana Event 16",
    },
    {
        id: 17,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407630/WhatsApp_Image_2025-02-01_at_11.56.39_AM_ntwz5h.jpg",
        alt: "Ludhiana Event 17",
    },
    {
        id: 18,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407630/WhatsApp_Image_2025-02-01_at_11.56.38_AM_onswe9.jpg",
        alt: "Ludhiana Event 18",
    },
    {
        id: 19,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407629/WhatsApp_Image_2025-02-01_at_11.56.37_AM_q7noz7.jpg",
        alt: "Ludhiana Event 19",
    },
    {
        id: 20,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407628/WhatsApp_Image_2025-02-01_at_11.56.36_AM_r5rga5.jpg",
        alt: "Ludhiana Event 20",
    },
    {
        id: 21,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407628/WhatsApp_Image_2025-02-01_at_11.56.35_AM_holvpz.jpg",
        alt: "Ludhiana Event 21",
    },
    {
        id: 22,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407627/WhatsApp_Image_2025-02-01_at_11.56.34_AM_ly7fba.jpg",
        alt: "Ludhiana Event 22",
    },
    {
        id: 23,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407626/WhatsApp_Image_2025-02-01_at_11.56.33_AM_obakbd.jpg",
        alt: "Ludhiana Event 23",
    },
    {
        id: 24,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407626/WhatsApp_Image_2025-02-01_at_11.56.33_AM_1_o871yb.jpg",
        alt: "Ludhiana Event 24",
    },
    {
        id: 25,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407625/WhatsApp_Image_2025-02-01_at_11.56.29_AM_ecbx4z.jpg",
        alt: "Ludhiana Event 25",
    },
    {
        id: 26,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407625/WhatsApp_Image_2025-02-01_at_11.56.28_AM_pkw0x0.jpg",
        alt: "Ludhiana Event 26",
    },
    {
        id: 27,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407625/WhatsApp_Image_2025-02-01_at_11.56.32_AM_mr9cvi.jpg",
        alt: "Ludhiana Event 27",
    },
    {
        id: 28,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407624/WhatsApp_Image_2025-02-01_at_11.56.30_AM_jqqlvo.jpg",
        alt: "Ludhiana Event 28",
    },
    {
        id: 29,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407624/WhatsApp_Image_2025-02-01_at_11.56.26_AM_pwhzks.jpg",
        alt: "Ludhiana Event 29",
    },
    {
        id: 30,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407624/WhatsApp_Image_2025-02-01_at_11.56.24_AM_mfcvjk.jpg",
        alt: "Ludhiana Event 30",
    },
    {
        id: 31,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407624/WhatsApp_Image_2025-02-01_at_11.56.28_AM_1_kme8lw.jpg",
        alt: "Ludhiana Event 31",
    },
    {
        id: 32,
        src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738407624/WhatsApp_Image_2025-02-01_at_11.56.27_AM_m792pq.jpg",
        alt: "Ludhiana Event 32",
    },
];